var _style, _g, _g2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwake1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{font-family:'MyriadPro-Regular';}\n\t.st1{font-size:42.5772px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,145.7c-37.3,0-67.7-30.4-67.7-67.7c0-37.3,30.4-67.7,67.7-67.7c37.3,0,67.7,30.4,67.7,67.7 C145.7,115.3,115.3,145.7,78,145.7z M78,15c-34.7,0-63,28.3-63,63s28.3,63,63,63s63-28.3,63-63S112.7,15,78,15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,72.8c3.1,1.6,9.1,4,16.8,4.1c8.7,0.1,16.7-2.7,16.4-3.5c-0.2-0.5-3.5-0.7-16.8,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3,73.8c2.8,1,8,2.6,14.8,2.7c7.6,0.1,14.7-1.8,14.4-2.3c-0.2-0.3-3.1-0.4-14.8,0.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78,
    cy: 108.7,
    rx: 12.4,
    ry: 6.2
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 95.6541 53.8872)",
    className: "st0 st1"
  }, "z")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 127.9632 25.4629)",
    className: "st0 st1"
  }, "z")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwake1);
export default __webpack_public_path__ + "static/media/Awake1.13e2ee1e41c6b45b86af64ce0cf7d426.svg";
export { ForwardRef as ReactComponent };